import { gql } from '@apollo/client';

// Input types for Profile Values GraphQL operations
export interface CreateProfileValueInputType {
  agent_id: string;
  profile_id: string;
  attribute_id: string;
  activity_id?: string;
  value: any; // Can be any type based on the attribute
}

export interface UpdateProfileValueInputType {
  profile_value_id: string;
  agent_id: string;
  value?: any;
}

export interface GetProfileValuesInputType {
  agent_id: string;
}

export const CREATE_PROFILE_VALUE = gql`
  mutation create_profile_value($data: CreateProfileValueInputType) {
    create_profile_value(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_PROFILE_VALUE = gql`
  mutation update_profile_value($data: UpdateProfileValueInputType) {
    update_profile_value(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_PROFILE_VALUES = gql`
  query get_profile_values($data: GetProfileValuesInputType) {
    get_profile_values(data: $data) {
      hasError
      message
      data
    }
  }
`;